export default {
  title: 'Fanhan Tech'
}



// WEBPACK FOOTER //
// ./src/lang/en/footer.js